// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","895":"component---src-templates-page-tsx"}[chunkId] + "-" + {"351":"f66732a75a303e487768","532":"70299dff690a617f2b68","895":"8694be219f6e439d79f5"}[chunkId] + ".js";
};